import { configPublic } from '@src/config.public'
import { QUERY_PARAMS } from '@src/utils/constants.util'

export const MY_PROGRESS_IN_PROGRESS_VARIANT = 'inProgress_v1'
export const MY_PROGRESS_LIMITED_EDITION_VARIANT = 'limitedEdition_v1'
export const MY_PROGRESS_RECENTLY_EARNED_VARIANT = 'recentlyEarned_v1'
export const MY_PROGRESS_WORKOUT_STATS_VARIANT = 'workoutStats_v1'

const MY_PROGRESS_OFF_VALUES = ['none', 'off']

type SearchParams = Record<string, string | string[] | undefined>

/** The myProgress query override is a QA aid, so it is ignored in production. */
export function resolveMyProgressVariant(searchParams?: SearchParams): string {
  if (configPublic.general.isProduction) return configPublic.myProgressModuleAdditional

  const raw = searchParams?.[QUERY_PARAMS.myProgress]
  const value = Array.isArray(raw) ? raw[0] : raw

  if (!value) return configPublic.myProgressModuleAdditional
  if (MY_PROGRESS_OFF_VALUES.includes(value)) return ''
  if (
    value === MY_PROGRESS_IN_PROGRESS_VARIANT ||
    value === MY_PROGRESS_LIMITED_EDITION_VARIANT ||
    value === MY_PROGRESS_RECENTLY_EARNED_VARIANT ||
    value === MY_PROGRESS_WORKOUT_STATS_VARIANT
  ) {
    return value
  }

  return configPublic.myProgressModuleAdditional
}

export function isWorkoutStatsEnabled(
  variant: string = configPublic.myProgressModuleAdditional
): boolean {
  return variant === MY_PROGRESS_WORKOUT_STATS_VARIANT
}
